import type { $ } from "../../../dom";
import { Input, type InputOptions } from "../../core";

export type CheckboxInputOptions<T> = InputOptions<T> & {};

export abstract class CheckboxInput<TValue, TData = TValue> extends Input<
  TValue,
  TData
> {
  constructor($: $, options: CheckboxInputOptions<TValue>) {
    const { ...superOptions } = options;

    super($, superOptions);

    this.$input.on("input:relkit-input", () => this.triggerInput());
    this.$input.on("change:relkit-input", () => this.triggerChange());
  }

  toggle() {
    this.isActive = !this.isActive;
  }

  get isActive(): boolean {
    return this.$input.first instanceof HTMLInputElement
      ? this.$input.first.checked
      : false;
  }

  set isActive(value: boolean) {
    if (this.$input.first instanceof HTMLInputElement) {
      this.$input.first.checked = value;

      this.triggerInput();
      this.triggerChange();
    }
  }
}
